<section class="main-hero">
  <div class="container-fluid">
    <div class="sesction-banner">
      <div class="hero-content">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-10 col-lg-6">
            <span class="do-yourself text-center">
              <span>Do-It-Yourself</span>
            </span>
            <h1 class="mb-4 font-600">
              Create & Download
              <span class="text-primary d-block">Video/Card Invitation's</span>
              in minutes
            </h1>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Search for any invitation template"
                (keypress)="keyPress($event)"
                [(ngModel)]="searchterm"
              />
              <div class="input-group-append">
                <button
                  class="btn-search-hero"
                  type="button"
                  (click)="search()"
                >
                  <span class="material-icons"> search </span>
                </button>
              </div>
            </div>
            <!-- <div class="d-block d-md-none btn-search-mobile">
              <div class="position-relative">
                <span class="material-icons search-icon">
                  search
                </span>
                <input type="text" class="form-control" placeholder="Search for any invitation template..."
                  [(ngModel)]="searchterm" />
              </div>
              <button class="btn btn-secondary bg-pink mt-2 w-100 btn-bottom" type="button" (click)="search()">
                Search
              </button>
            </div> -->
            <div class="popular">
              Invitation Categories:
              <ul>
                <li>
                  <a
                    [routerLink]="'/wedding-invitation-maker'"
                    class="text-body-2"
                    data-uw-rm-brl="false"
                    >Wedding</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="'/birthday-Invitation-maker'"
                    class="text-body-2"
                    data-uw-rm-brl="false"
                    >Birthday</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="'/More-Invitation'"
                    class="text-body-2"
                    data-uw-rm-brl="false"
                    >Baby & Kids/ Naming Ceremony</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="'/house-inaugration-invitation'"
                    class="text-body-2"
                    data-uw-rm-brl="false"
                    >House warming</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="design-right-middle"></div>
</section>
<div class="fresh-ui">
  <section class="primary-categories">
    <div class="container-fluid">
      <div class="mb-5">
        <h2 class="site-title title-fonts text-center">
          Invitation Categories
        </h2>
        <div class="text-center">
          <img
            src="{{ assetURL }}/assets/images/title-decor.svg"
            width="100%"
            height="100%"
            class="img-decor-top"
            alt="247Invites"
          />
        </div>
      </div>
      <!-- <h3 class="sub-heading text-center mb-5">Browse most loved category</h3> -->
      <div class="home-category-container">
        <div
          class="home-category-column mb-4"
          *ngIf="masterSubCategory.length > 0"
        >
          <div>
            <div class="cate-card">
              <a routerLink="/wedding-invitation-maker">
                <img
                  src="{{ assetURL }}/assets/images/wedding-invites-cat.webp"
                  width="100%"
                  height="100%"
                  alt="247Invites"
                />
              </a>
            </div>
            <div class="card-heading pt-3 pb-2">
              <a routerLink="/wedding-invitation-maker">
                <p class="card-head text-center mb-0">Wedding Invite</p>
              </a>
            </div>
          </div>
        </div>
        <div
          class="home-category-column mb-4"
          *ngIf="masterSubCategory.length > 0"
        >
          <div>
            <div class="cate-card">
              <a routerLink="/birthday-Invitation-maker">
                <img
                  src="{{ assetURL }}/assets/images/BirthDay.webp"
                  width="100%"
                  height="100%"
                  alt="247Invites"
                />
              </a>
            </div>
            <div class="card-heading pt-3 pb-2">
              <a routerLink="/birthday-Invitation-maker">
                <p class="card-head text-center mb-0">Birthday Invite</p>
              </a>
            </div>
          </div>
        </div>
        <div
          class="home-category-column mb-4"
          *ngFor="let subCategory of masterSubCategory"
        >
          <div>
            <div class="cate-card">
              <a [routerLink]="subCategory.SubCategorySlug">
                <img
                  src="{{ assetURL }}/{{ subCategory?.SubCategoryImage }}"
                  width="100%"
                  height="100%"
                  alt="247Invites"
                />
              </a>
            </div>
            <div class="card-heading pt-3 pb-2">
              <a [routerLink]="subCategory.SubCategorySlug">
                <p class="card-head text-center mb-0">
                  {{ subCategory?.SubCategoryName }}
                </p>
              </a>
            </div>
          </div>
        </div>
        <div class="invisible-column"></div>
        <div class="invisible-column"></div>
      </div>
      <div class="row justify-content-center mx-auto pt-3 pt-md-5">
        <div class="col-12 col-md-auto">
          <button
            type="button"
            [routerLink]="['/categories']"
            class="btn-247 btn-primary-outline-main btn-large w-100"
          >
            Explore All
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="site-trending make-it-premium site-padding">
    <div class="container-fluid">
      <div class="mb-5">
        <h2 class="site-title title-fonts text-center">Make it premium</h2>
        <div class="text-center">
          <img
            src="{{ assetURL }}/assets/images/title-decor.svg"
            width="100%"
            height="100%"
            class="img-decor-top"
            alt="247Invites"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <a (click)="editForMe()">
            <div class="trending-videos">
              <img
                src="{{ assetURL }}/assets/images/sam-wedding.webp"
                width="100%"
                height="100%"
                class="img-fluid make-premium-img1"
                alt="trending invites"
              />
            </div>
            <div class="card-help-text">
              <h4 class="title-sub-fonts">We Will Create Invite For You</h4>
              <ul class="list-disc space-y-2 mb-8">
                <li class="paragraph-medium 2xl:paragraph-large">
                  Our experts create the Invite for you
                </li>
                <li class="paragraph-medium 2xl:paragraph-large">
                  Get the invite customized for a little extra cost
                </li>
                <li class="paragraph-medium 2xl:paragraph-large">
                  Easy, quick, and hassle-free process
                </li>
              </ul>
              <a
                class="text-500 general_sans btn-large btn-primary-main btn-full-radius w-100 d-block"
                (click)="editForMe()"
                >Order Now</a
              >
            </div>
          </a>
        </div>
        <div class="col-md-6 m-mt-40">
          <a (click)="premiumInvites()">
            <div class="trending-videos">
              <img
                src="{{ assetURL }}/assets/images/prem-invites.webp"
                width="100%"
                height="100%"
                class="img-fluid make-premium-img"
                alt="trending invites"
              />
            </div>
            <div class="card-help-text">
              <h4 class="title-sub-fonts">Send Invites in an Envelope</h4>
              <ul class="list-disc space-y-2 mb-8">
                <li class="paragraph-medium 2xl:paragraph-large">
                  Open a digital envelope with a single click
                </li>
                <li class="paragraph-medium 2xl:paragraph-large">
                  Your invite beautifully presented inside
                </li>
                <li class="paragraph-medium 2xl:paragraph-large">
                  Share easily via a unique web link
                </li>
              </ul>
              <a
                class="text-500 general_sans btn-large btn-primary-outline-main btn-full-radius w-100 d-block"
                >Watch in Action</a
              >
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
  <home-slider></home-slider>
  <app-user-review></app-user-review>
  <section class="guide-info site-padding">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="mb-5">
            <h2 class="site-title title-fonts text-center text-white">
              Instantly Craft Invitations & Greetings with 247Invites.com!
            </h2>
            <div class="text-center">
              <img
                src="{{ assetURL }}/assets/images/title-decor-light.svg"
                width="100%"
                height="100%"
                class="img-decor-top"
                alt="247Invites"
              />
            </div>
          </div>
        </div>
      </div>
      <p class="text-center">
        Introducing 247Invites, the ultimate solution for creating stunning
        invitation and greeting videos instantly! Whether you're planning a
        birthday party, wedding, anniversary, or any special occasion,
        247Invites has got you covered with its incredible features and
        user-friendly interface.
      </p>
      <p class="text-center">
        Gone are the days of spending hours designing and editing invitations
        manually. With 247Invites, you can create personalized and eye-catching
        videos in a matter of minutes. Simply choose from a wide range of
        professionally designed templates and customize them to match your
        event's theme and style. Add your own text, photos, and videos, and let
        247Invites transform them into an unforgettable invitation or greeting
        video.
      </p>
      <p class="text-center">
        With 247Invites, you have complete control over the creative process.
        experiment with different fonts, colors, and animations to make your
        invitation truly unique. Spice it up with music or narration to set the
        perfect tone for your event. The possibilities are endless, and the
        results are always impressive. What sets 247Invites apart is its instant
        rendering capability. No more waiting around for hours or days to
        receive your video. With our advanced technology, your video will be
        ready for download or sharing in no time, ensuring a hassle-free
        experience for you and your guests. Don't settle for ordinary
        invitations and greetings. Create extraordinary memories with
        247Invites. Try it today and see how easy and fun it is to make amazing
        invitation and greeting videos instantly!
      </p>
      <div class="guide-row">
        <div class="guide-card">
          <img
            src="{{ assetURL }}/assets/images/new-video-icon.svg"
            width="100%"
            height="100%"
            alt="Make Free
            Video"
          />
          <div class="card-content">
            <h5 class="card-title">Make Video</h5>
          </div>
        </div>
        <div class="guide-card">
          <img
            src="{{ assetURL }}/assets/images/new-thumb-icon.svg"
            width="100%"
            height="100%"
            alt="Low Price"
          />
          <div class="card-content">
            <h5 class="card-title">Low Price</h5>
          </div>
        </div>
        <div class="guide-card">
          <img
            src="{{ assetURL }}/assets/images/new-cake-icon.svg"
            width="100%"
            height="100%"
            alt="Video For
            Any Occasion"
          />
          <div class="card-content">
            <h5 class="card-title">Video For Any Occasion</h5>
          </div>
        </div>
        <div class="guide-card">
          <img
            src="{{ assetURL }}/assets/images/new-engineering-icon.svg"
            width="100%"
            height="100%"
            alt="No
            Skill Needed"
          />
          <div class="card-content">
            <h5 class="card-title">No Skill Needed</h5>
          </div>
        </div>
        <div class="guide-card">
          <img
            src="{{ assetURL }}/assets/images/new-preview-icon.svg"
            width="100%"
            height="100%"
            alt="Preview
            Video Instantly"
          />
          <div class="card-content">
            <h5 class="card-title">Preview Video Instantly</h5>
          </div>
        </div>
        <div class="guide-card">
          <img
            src="{{ assetURL }}/assets/images/new-devices-icon.svg"
            width="100%"
            height="100%"
            alt="Mobile
            &amp; Desktop Formats"
          />
          <div class="card-content">
            <h5 class="card-title">Mobile &amp; Desktop Formats</h5>
          </div>
        </div>
        <div class="guide-card">
          <img
            src="{{ assetURL }}/assets/images/new-share-icon.svg"
            width="100%"
            height="100%"
            alt="Share on
            Social Media"
          />
          <div class="card-content">
            <h5 class="card-title">Share on Social Media</h5>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="site-padding why-choose">
    <div class="container-fluid">
      <div class="mb-5">
        <h2 class="site-title title-fonts text-center">
          Why choose 247Invites.com?
        </h2>
        <div class="text-center">
          <img
            src="{{ assetURL }}/assets/images/title-decor.svg"
            width="100%"
            height="100%"
            class="img-decor-top"
            alt="247Invites"
          />
        </div>
      </div>
      <div class="row align-start-center justify-content-md-center">
        <div class="col-md-4">
          <div class="text-center">
            <img
              src="{{ assetURL }}/assets/images/why-choose-us-1.svg"
              width="100%"
              height="100%"
              alt="247Invites"
            />
            <p>
              247Invites.com is the most widely used online Video Invitation and
              E-Cards Platform trusted by over 900000 customers. It is a very
              easy to use platform and does not requires any technical skills.
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="text-center">
            <img
              src="{{ assetURL }}/assets/images/why-choose-us-2.svg"
              width="100%"
              height="100%"
              alt="247Invites"
            />
            <p>
              Personalize your Invitations with your Names, Event Details,
              Photos and Music and preview your video invitation for free!!!!
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="text-center">
            <img
              src="{{ assetURL }}/assets/images/why-choose-us-3.svg"
              width="100%"
              height="100%"
              alt="247Invites"
            />
            <p>
              Each of our video Invitation theme is Unique, Premium, Exclusive,
              Well-crafted and Affordable.
            </p>
          </div>
        </div>
        <div class="col-md-4 m-mt-40">
          <div class="text-center">
            <img
              src="{{ assetURL }}/assets/images/why-choose-us-4.svg"
              width="100%"
              height="100%"
              alt="247Invites"
            />
            <p>
              You will find a perfect video invitation and Ecards within your
              budget.
            </p>
          </div>
        </div>
        <div class="col-md-4 m-mt-40">
          <div class="text-center">
            <img
              src="{{ assetURL }}/assets/images/why-choose-us-5.svg"
              width="100%"
              height="100%"
              alt="247Invites"
            />
            <p>
              Our invitations or greetings are not just videos, but an occasion
              to tell the story of your love & make it memorable through your
              photos & music!
            </p>
          </div>
        </div>
        <div class="col-md-4 m-mt-40">
          <div class="text-center">
            <img
              src="{{ assetURL }}/assets/images/why-choose-us-6.svg"
              width="100%"
              height="100%"
              alt="247Invites"
            />
            <p>
              Just download your video invitation and share it over WhatsApp,
              Facebook, Instagram and other social networks easily!
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<!-- <section>
  <div class="d-md-block">
    <app-trending-invites [featuredVideoData]="FeaturedVideoData" [featuredCardData]="getCardData(1)">
    </app-trending-invites>
  </div>
</section> -->

<div class="fresh-ui">
  <!-- <section class="site-trending site-padding">
    <div class="container">
      <h2 class="site-title text-500 general_sans text-center mb-5">
        Explore what's <span class="text-main">trending</span>
      </h2>
      <div class="scrolling-card-container">
        <div class="scrolling-card">
          <div class="trending-videos">
            <img src="/assets/images/trending-wedding.png" class="img-fluid" alt="trending wedding invites">
          </div>
          <div class="cate-name general_sans text-500">
            <span>
              Wedding card & video
            </span>
            <span class="btn-go">
              <span class="material-icons text-white">
                arrow_forward
              </span>
            </span>
          </div>
        </div>
        <div class="scrolling-card">
          <div class="trending-videos">
            <img src="/assets/images/trending-birthday.png" class="img-fluid" alt="trending birthday invites">
          </div>
          <div class="cate-name general_sans text-500">
            <span>
              Birthday invitations
            </span>
            <span class="btn-go">
              <span class="material-icons text-white">
                arrow_forward
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <!-- <section class="category-title">
    <div class="container">
      <h2 class="site-title-xl text-500 general_sans text-center">
        247 Invites <span class="text-main text-highlight">Categories</span>
      </h2>
    </div>
  </section>
  <section class="site-birthday site-padding">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-md-6 col-12 order-2 order-md-1">
          <div class="birthday-videos mt-3 mt-md-0">
            <img src="/assets/images/birthday-card.png" class="img-fluid" alt="trending birthday invites">
          </div>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md order-1 order-md-3">
          <h2 class="site-title text-500 general_sans mb-4 mb-md-5">
            <span class="text-orange247">Celebrate in style, </span> Craft your perfect
            birthday experience
          </h2>
          <div class="general-cate-name general_sans text-500">
            <span>
              Birthday invitations
            </span>
            <span class="btn-go">
              <span class="material-icons text-white">
                arrow_forward
              </span>
            </span>
          </div>
          <div class="general-cate-name general_sans text-500">
            <span>
              Birthday cards
            </span>
            <span class="btn-go">
              <span class="material-icons text-white">
                arrow_forward
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="site-wedding site-padding">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-md">
          <h2 class="site-title text-500 general_sans mb-4 mb-md-5">
            Exquisite <span class="text-blue247">wedding video invitations </span> for your be loved one
          </h2>
          <div class="general-cate-name general_sans text-500">
            <span>
              Save the date
            </span>
            <span class="btn-go">
              <span class="material-icons text-white">
                arrow_forward
              </span>
            </span>
          </div>
          <div class="general-cate-name general_sans text-500">
            <span>
              Engagement party
            </span>
            <span class="btn-go">
              <span class="material-icons text-white">
                arrow_forward
              </span>
            </span>
          </div>
          <div class="general-cate-name general_sans text-500">
            <span>
              Wedding invitations
            </span>
            <span class="btn-go">
              <span class="material-icons text-white">
                arrow_forward
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-1"></div>

        <div class="col-md-6">
          <div class="wedding-videos">
            <img src="/assets/images/wedding-card.png" class="img-fluid" alt="trending wedding invites">
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="site-babyshower site-padding">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-md-6 col-12 order-2 order-md-1">
          <div class="babyshower-videos">
            <img src="/assets/images/babyshower-card.png" class="img-fluid" alt="trending babyshower invites">
          </div>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md order-1 order-md-3">
          <h2 class="site-title text-500 general_sans mb-4 mb-md-5">
            Craft your perfect <span class="text-gold247">baby shower experience</span>
          </h2>
          <div class="general-cate-name general_sans text-500">
            <span>
              Baby shower invitations
            </span>
            <span class="btn-go">
              <span class="material-icons text-white">
                arrow_forward
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <!-- <section class="more-categories site-padding">
    <div class="container-fluid">
      <div class="more-categories-card">
        <div class="d-flex justify-content-center position-relative">
          <img class="reason-img-1 img-fluid card-img" src="/assets/images/festivals.png" alt="festivals invites">
          <img class="reason-img-2 img-fluid card-img" src="/assets/images/baptism.png" alt="baptism invites">
          <img class="reason-img-1 img-fluid card-img" src="/assets/images/baptism1.png" alt="baptism invites">
          <img class="reason-img-2 img-fluid card-img" src="/assets/images/house-warming.png" alt="house warming">
          <img class="reason-img-1 img-fluid card-img" src="/assets/images/kids.png" alt="birthday videos">
        </div>
        <br class="d-none d-md-block"><br class="d-none d-md-block">
        <h2 class="site-title text-500 general_sans text-center my-0 mb-3 md-mb-5 my-md-5">
          <span class="text-green247">More reasons </span> to celebrate
        </h2>
        <div class="row">
          <div class="col-md-4" *ngFor="let additionalSubCategoryItem of additionalSubCategory">
            <a [href]="
            siteURL +
            additionalSubCategoryItem.CategoryDesc +
              '/' +
              additionalSubCategoryItem.SubCategoryName +
              '/videos-invitation-maker'
              | formateUrl
                : 'categoryId=' +
                additionalSubCategoryItem.CategoryId +
                    '&subCategoryId=' +
                    additionalSubCategoryItem?.SubCategoryId
          ">
              <span class="general-cate-name general_sans text-500 bg-white-100">
                <span>
                  {{additionalSubCategoryItem.SubCategoryName}}
                </span>
                <span class="btn-go">
                  <span class="material-icons text-white">
                    arrow_forward
                  </span>
                </span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section> -->
</div>
